import React from 'react';
import Skeleton from '../../../../../../shared/components/ui/Skeleton/Skeleton';

const AnalysisSkeleton = () => {
    return (
        <div className="analysis-result-page">
            {/* Topbar Skeleton */}
            <div className="stepper-section" style={{ borderBottom: '1px solid #e2e8f0', padding: '1rem 2rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                    <Skeleton variant="rect" width={40} height={40} style={{ borderRadius: '8px' }} />
                    <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                        <Skeleton variant="rect" width={180} height={32} style={{ borderRadius: '20px' }} />
                        <Skeleton variant="rect" width={120} height={32} style={{ borderRadius: '20px' }} />
                        <Skeleton variant="rect" width={100} height={32} style={{ borderRadius: '20px' }} />
                    </div>
                </div>
            </div>

            {/* KPI Row Skeleton */}
            <div className="info-cards-row" style={{ padding: '1.5rem 2rem' }}>
                {[...Array(4)].map((_, i) => (
                    <div key={i} className="info-card" style={{ background: 'white', padding: '1.25rem', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                        <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', marginBottom: '1rem' }}>
                            <Skeleton variant="circle" width={14} height={14} />
                            <Skeleton variant="text" width="40%" height={10} />
                        </div>
                        <Skeleton variant="text" width="80%" height={20} style={{ marginBottom: '0.5rem' }} />
                        <Skeleton variant="text" width="50%" height={12} />
                    </div>
                ))}
            </div>

            <div className="final-review-workspace" style={{ display: 'flex', height: 'calc(100vh - 250px)' }}>
                {/* Sidebar Skeleton */}
                <div style={{ width: '280px', background: 'white', borderRight: '1px solid #e2e8f0', padding: '1.5rem' }}>
                    <Skeleton variant="text" width="60%" height={16} style={{ marginBottom: '2rem' }} />
                    {[...Array(8)].map((_, i) => (
                        <div key={i} style={{ marginBottom: '1.5rem' }}>
                            <Skeleton variant="text" width="90%" height={14} />
                        </div>
                    ))}
                </div>

                {/* Editor Skeleton */}
                <div style={{ flex: 1, padding: '3rem', background: '#F8F9FA' }}>
                    <div style={{ maxWidth: '900px', margin: '0 auto', background: 'white', padding: '3rem', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3rem' }}>
                            <Skeleton variant="text" width="40%" height={32} />
                            <div style={{ display: 'flex', gap: '1rem' }}>
                                <Skeleton variant="rect" width={100} height={32} style={{ borderRadius: '8px' }} />
                                <Skeleton variant="rect" width={80} height={32} style={{ borderRadius: '8px' }} />
                            </div>
                        </div>

                        {[...Array(3)].map((_, i) => (
                            <div key={i} style={{ marginBottom: '2.5rem' }}>
                                <Skeleton variant="text" width="30%" height={20} style={{ marginBottom: '1rem' }} />
                                <Skeleton variant="text" width="100%" height={12} />
                                <Skeleton variant="text" width="95%" height={12} />
                                <Skeleton variant="text" width="98%" height={12} />
                                <Skeleton variant="text" width="60%" height={12} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Footer Skeleton */}
            <div className="global-submission-actions-container">
                <Skeleton variant="rect" width={120} height={44} style={{ borderRadius: '12px' }} />
            </div>
        </div>
    );
};

export default AnalysisSkeleton;
